// extracted by mini-css-extract-plugin
export default {"inner":"Error_inner__4j3Z5"};